import { gql } from '@apollo/client'
import { PICOS_PRIORITY_OVERVIEW_FRAGMENT } from './PicOSPriorityOverviewFragment'

export const ALL_PRIORITIES_COMPLIANCE_FRAGMENT = gql`
  fragment AllPrioritiesCompliance on PicOSPrioritySalesCentersCompliance {
    id
    priority {
      ...PicOSPriorityOverview
    }
    remainingToTargetExecution
    expectedUnitSales
    regionCompliance {
      id
      name
      compliancePercentage
      priorityId
    }
  }
  ${PICOS_PRIORITY_OVERVIEW_FRAGMENT}
`
